
import { defineComponent } from 'vue'
import { DateTime } from 'luxon'
import { DATE_FORMAT_HUMAN } from '@/constants/date.const'

export default defineComponent({
  name: 'AdsibInformationComponent',
  props: {
    adsibInformation: { type: Object }
  },
  setup () {
    return {
      DateTime,
      DATE_FORMAT_HUMAN
    }
  }
})
